import React, { PureComponent } from 'react';
import classNames from 'classnames';
import DisplayComponent from '../BaseComponents/DisplayComponent';
import './PopLockSection.module.css';

const PopLockItem = DisplayComponent(
  class PopLockItem extends PureComponent {
    render() {
      const {
        children,
        lockedSide,
        id,
        backgroundColor,
        textColor,
        padding
      } = this.props;
      return (
        <div
          id={id}
          styleName={classNames('side', `locked-${lockedSide}`)}
          style={{ background: backgroundColor, color: textColor }}
        >
          <div styleName={classNames({ content: padding }, 'height-fix')}>
            {children}
          </div>
        </div>
      );
    }
  }
);

export default PopLockItem;
